import { type FunctionalComponent, h } from '@stencil/core';

interface IMessageSectionPartial {
  text: string;
  color: string;
}

export const MessageSectionPartial = (
  props
): FunctionalComponent<IMessageSectionPartial> => {
    const actionEvent = new CustomEvent('compare:messageCloseAction', {
      detail: {
        isInformative: props.color.includes('informative') || props.color.includes('red') ? true : false,
      },
    });

    return (
      <section
        class={`compare-wrapper-message compare-wrapper-message--${props.color}`}
      >
        <se-icon size="small">information_stroke</se-icon>
        <span>{props.text}</span>
        <se-icon
          class="compare-wrapper-message__close-icon"
          onClick={(e) => {
              document.dispatchEvent(actionEvent);
              e.preventDefault();
          }}
          size="small"
        >
        notification_error_plain
        </se-icon>
      </section>
    );
};
